import React from 'react';
import { connect } from 'react-redux';
import { IonButton, IonIcon } from '@ionic/react';
import Loading from '../../components/spinner';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { checkmarkCircle, closeCircleSharp } from 'ionicons/icons';
import './index.css';
import { Title, NormalText } from '../../components/common';
import { forwardTo } from '../../lib/utils';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

const isWeb = () => Capacitor.getPlatform() === 'web';

const MembershipCompleted = ({ __, isMenuFlow, clientProfile }) => {
  const handleMembership = () => {
    if (Capacitor.isNativePlatform()) {
      Browser.close()
    }
    forwardTo('/my-membership');
  };

  const handleCheckout = () => {
    forwardTo('/membership');
  };
  const success = !window.location.href.includes('canceled=true')
  if (success) {
    forwardTo('/my-membership', { success: true });
  } else {
    return (<Loading transparent>
      <Layout hideSecondToolbar={true} color="transparent" headerTitle={__('Membership Canceled')}>
        <div className="absolute-content flex-row-wrapper">
          <div className="scrollable-y ion-text-center centered" style={{ textAlign: 'center' }}>
            <IonIcon
              expand="block"
              color="danger"
              icon={closeCircleSharp}
              className="success-icon"

            />
            <Title className={'block centered'}>{__('Payment Canceled')}</Title>
          </div>
          <div className="flex-min">
            <IonButton
            className='button-uppercase'
              color="primary"
              expand="block"
              onClick={handleCheckout}
            >
              {__('Go back')}
            </IonButton>
          </div>
        </div>
      </Layout>
    </Loading>)


  }
}

const mapStateToProps = (store) => ({
  isMenuFlow: store.subscription.flow === 'menu_flow',
  clientProfile: store.common.clientProfile,
});

export default connect(mapStateToProps)(withTranslation(MembershipCompleted));
